module.exports = __webpack_public_path__ + "img/pointcard-bg.a9da86f5.png";